const registerContent = {
  title: "auth.REGISTER_TEXT",
  description: "general.AUTH_DESCRIPTION",
  firstInputTitle: "auth.PHONE_NUMBER",
  step1Button: "auth.CONFIRM",
  step3Button: "auth.CONFIRM",
  step4Button: "auth.CONFIRM",
  haveAccount: "auth.HAVE_ACCOUNT",
  loginLink: "auth.LOGIN_TO_ACCOUNT",
  OtpInputTitle: "auth.OTP_CODE",
  retrySend: "auth.RESEND",
  second: "auth.SECOND",
  Nid: "auth.NATIONAL_ID",
  birthDate: "auth.BIRTH_DATE",
  invitationCode: "auth.REFERRAL_CODE_OPTIONAL",
  password: "auth.PASSWORD",
  confirmPassword: "auth.REPEAT_PASSWORD",
  passwordCondition1: "auth.PASSWORD_CONDITION_1",
  passwordCondition2: "auth.PASSWORD_CONDITION_2",
  passwordCondition3: "auth.PASSWORD_CONDITION_3",
  passwordCondition4: "auth.PASSWORD_CONDITION_4",
  addCardText: "شماره کارت خود را وارد کنید.",
  loginText: "auth.CONFIRM_AND_LOGIN",
}

export default registerContent